import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/es6.number.max-safe-integer";
import _defineProperty from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/gva_web/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getRmRptBrwListByParams } from "@/api/rm_report_browse"; //  此处请自行替换地址
import infoList from "@/components/mixins/infoList";
import { formatTimeToStr } from "@/utils/data";
import { formatJson } from "@/utils";
export default {
  name: "viewlog",
  mixins: [infoList],
  data: function data() {
    return {
      listApi: getRmRptBrwListByParams,
      tableLoading: false,
      multipleSelection: [],
      searchInfo: {
        fromDay: "",
        toDay: "",
        nickName: "",
        operationDesc: "",
        operationObj: ""
      }
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return this.getTableData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    },
    //条件搜索前端看此方法
    onSearch: function onSearch() {
      this.page = 1;
      this.pageSize = 10;
      this.getTableData();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 导出数据
    handleExport: function handleExport() {
      var _this = this;
      // const queryParams = this.queryParams
      this.$confirm(this.$t("common.export_excel"), "", {
        confirmButtonText: this.$t("common.confirm"),
        cancelButtonText: this.$t("common.cancel"),
        type: "info"
      }).then(function () {
        _this.downloadLoading = true;
        import("@/vendor/Export2Excel").then(/*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(excel) {
            var tHeader, filterVal, table, list, data;
            return regeneratorRuntime.wrap(function (_context2) {
              while (1) switch (_context2.prev = _context2.next) {
                case 0:
                  tHeader = [_this.$t("reporting_log.username"), _this.$t("reporting_log.optime"), _this.$t("reporting_log.opdesc"), _this.$t("reporting_log.opobj")];
                  filterVal = ["nickName", "CreatedAt", "operationDesc", "operationObj"]; // 查询该条件下的全部页的数据
                  _context2.next = 1;
                  return _this.listApi(_objectSpread({
                    page: 1,
                    pageSize: Number.MAX_SAFE_INTEGER
                  }, _this.searchInfo));
                case 1:
                  table = _context2.sent;
                  list = table.data.list;
                  list.forEach(function (element) {
                    element.CreatedAt = _this.formatDate(element.CreatedAt);
                  });
                  // eslint-disable-next-line no-undef
                  data = formatJson(filterVal, list);
                  excel.export_json_to_excel({
                    header: tHeader,
                    data: data,
                    filename: _this.$t("reporting_log.export_file_name"),
                    autoWidth: true,
                    // Optional
                    bookType: "xlsx" // Optional
                  });
                  _this.downloadLoading = false;
                case 2:
                case "end":
                  return _context2.stop();
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      }).catch(function () {});
    }
  }
};